import React from "react";
import { TextField } from "@material-ui/core";
import priorityFeeFieldStyles from "./PriorityFeeFieldStyles";

interface PriorityFeeFieldProps {
    value: any;
    onChange: (e: any) => void;
    disabled?: boolean;
}

const PriorityFeeField = ({ value, onChange, disabled = false }: PriorityFeeFieldProps) => {
    const classes = priorityFeeFieldStyles();

    return (
        <TextField
            name="priorityFee"
            type="text"
            value={value ?? 0}
            disabled={disabled}
            onChange={onChange}
            inputProps={{
                inputMode: "decimal",
                onKeyPress: (event: any) => {
                    // Allow digits and a single decimal point only
                    const currentValue: string = (event.target as HTMLInputElement).value;
                    if (
                        !/[0-9.]/.test(event.key) ||
                        (event.key === "." && currentValue.includes("."))
                    ) {
                        event.preventDefault();
                    }
                },
                onPaste: (event: any) => {
                    const pasted = event.clipboardData.getData("text");
                    if (!/^\d*\.?\d*$/.test(pasted)) {
                        event.preventDefault();
                    }
                },
            }}
            variant="outlined"
            className={classes.priorityFeeTextField}
            InputProps={{
                classes: {
                    notchedOutline: disabled ? classes.disabledOutline : classes.enabledOutline,
                },
            }}
        />
    );
};

export default PriorityFeeField;
